<template src="./template.html"></template>
<style src="./styles.scss" lang="./scss" scoped></style>

<script>
  export default {
    name: 'LinkPreviewItem',
    props: { 'preview': Object },
    methods: {
      getContentClass() {
        if (this.preview) {
          return this.preview.video_url || this.preview.image ? 'col-sm-6 col-md-8' : ''
        }
      },
    },
  }
</script>
